import moment from 'moment';
import {joinedValuesSeparator, dateFormat} from '@/ts/DefaultTableConfigs';

export default class Refund {

    public id: string;
    public orderId: string;
    public totalAmount: number;
    public status: string;
    public refundDate: string;
    public completedDate: string;


    constructor(
        id: string,
        orderId: string,
        totalAmount: number,
        status: string,
        refundDate: string,
        completedDate: string,

    ) {
        this.id = id;
        this.orderId = orderId;
        this.totalAmount = totalAmount;
        this.status = status;
        this.refundDate =  moment(refundDate).local().format(dateFormat);
        this.completedDate =  completedDate ? moment(completedDate).local().format(dateFormat) : '';

    }
}
